module.exports = __webpack_public_path__ + "static/media/redQuotes.3248cf0e.svg";